import React, { Component } from "react";
import TextField from "material-ui/TextField";
import RaisedButton from "material-ui/RaisedButton";

import Tooltip from "rc-tooltip";
import ActionInfo from "material-ui/svg-icons/action/info-outline";
import {
  text_definition,
  primaryColor,
  debounceEventHandler,
} from "../../utils/utility";

import map from "lodash/map";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import some from "lodash/some";
import filter from "lodash/filter";
import difference from "lodash/difference";
import uniq from "lodash/uniq";

const styles = {
  raidoIcon: {
    color: "black",
  },
  divider: {
    borderBottom: "1px solid black",
    marginBottom: "6px",
  },
  iconStyle: {
    fill: primaryColor(),
  },
  textareaUnderlineStyle: {
    borderBottom: "1px solid red",
  },
  rootElementStyle: {
    height: "400px",
  },
  btnStyle: {
    background: primaryColor(),
    color: "#FFF",
  },
  searchStyle: {
    borderColor: primaryColor(),
  },
};

class ZipcodePanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ifZipcodeValid: true,
      zipcode: "",
      inValidZips: [],
    };
  }

  handleZipCode(e, newValue) {
    const matchArrs = newValue.match(/\b\d{5}\b/g);
    const arrs = newValue.split(",");
    const diff = difference(arrs, matchArrs);
    if (isEmpty(diff)) {
      this.setState({
        ifZipcodeValid: false,
        zipcode: newValue,
        inValidZips: [],
      });
    } else {
      this.setState({
        ifZipcodeValid: true,
        inValidZips: diff,
      });
    }
  }

  handleApplyClick(e) {
    if (!this.state.ifZipcodeValid) {
      const zipcodes = uniq(this.state.zipcode.split(","));
      this.props.addZipCode(zipcodes.join(","));
      this.setState({
        zipcode: "",
        ifZipcodeValid: true,
      });
      document.getElementById(this.refs.textarea.uniqueId).value = "";
    }
  }

  render() {
    return (
      <div className="light-grey-border p-20" style={{ height: "520px" }}>
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="light-grey-bottom-border pb-10"
        >
          <div>
            <strong>Zip code</strong>
          </div>
          <div></div>
        </div>
        <div
          className="show-zipcode clearfix pt-10 pb-10 light-grey-bottom-border"
          style={{
            display: this.props.zipcode.length > 0 ? "block" : "none",
            marginBottom: "5px",
            maxHeight: "60px",
            overflowY: "scroll",
          }}
        >
          {this.props.zipcode.map((item, index) => (
            <span
              className="text-muted text-light mr-10"
              style={{ float: "left" }}
              key={index}
            >
              <small>{item.zipcode}</small>
            </span>
          ))}

          <span className="text-orange-400 ml-10" style={{ float: "left" }}>
            <i className="icon-checkmark4 text-size-md " />
          </span>
        </div>
        <div
          className="light-grey-border pl-10 pr-10 pb-10 mb-20"
          style={{ height: this.props.zipcode.length > 0 ? "300px" : "340px" }}
        >
          <TextField
            fullWidth={true}
            multiLine={true}
            rows={1}
            rowsMax={11}
            underlineShow={false}
            hintText="Enter Zip Code(s) or Zip Code Range(s)"
            onChange={(e, newValue) => this.handleZipCode(e, newValue)}
            errorText={this.state.errorText}
            ref="textarea"
          />
        </div>
        <div className="mb-5">
          If entering multiple zip codes or zip code ranges, separate each with
          a comma
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ color: "#FF0000" }}>
            {!isEmpty(this.state.inValidZips) &&
              "Some invalid zipcodes: " + this.state.inValidZips.join(",")}
          </div>
          <div>
            <RaisedButton
              label="Apply"
              buttonStyle={styles.btnStyle}
              labelColor="#FFF"
              disabled={this.state.ifZipcodeValid}
              onTouchTap={(e) => this.handleApplyClick(e)}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ZipcodePanel;



// WEBPACK FOOTER //
// ./src/components/AudienceBuilder/ZipcodePanel.js